import { FiEye, FiTrash2, FiEdit } from "react-icons/fi";

const StatusBadge = ({ status }) => {
  const getStatusStyles = () => {
    switch (status) {
      case "In Transit":
        return "bg-blue-100 text-blue-700";
      case "Arrived at Port":
        return "bg-purple-100 text-purple-700";
      case "Customs Cleared":
        return "bg-emerald-100 text-emerald-700";
      case "Delivered":
        return "bg-green-100 text-green-700";
      case "Departed from Origin Port":
        return "bg-amber-100 text-amber-700";
      default:
        return "bg-gray-100 text-gray-700";
    }
  };

  return (
    <span
      className={`rounded-full px-3 py-1 text-xs font-medium ${getStatusStyles()}`}
    >
      {status || "In Transit"}
    </span>
  );
};

const ContainerCard = ({ container, onView, onEdit, onDelete }) => {
  const formatDate = (date) => {
    if (!date) return "N/A";
    const d = new Date(date);
    if (Number.isNaN(d.getTime())) return "N/A";
    return d.toLocaleDateString("en-GB");
  };

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4 shadow-sm transition hover:shadow-md">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div>
          <h3 className="text-lg font-semibold">
            {container.bookingBLNo || "N/A"}
          </h3>
          <p className="text-sm text-gray-500">
            {container.containerNumber || "N/A"}
          </p>
        </div>
        <StatusBadge status={container.status} />
      </div>

      <div className="space-y-2 text-sm">
        <div className="flex justify-between gap-4">
          <span className="text-gray-600">Date:</span>
          <span className="font-medium">{formatDate(container.date)}</span>
        </div>

        <div className="flex justify-between gap-4">
          <span className="text-gray-600">Vessel:</span>
          <span className="font-medium">{container.vesselName || "N/A"}</span>
        </div>

        <div className="flex justify-between gap-4">
          <span className="text-gray-600">Origin:</span>
          <span className="font-medium">{container.origin || "N/A"}</span>
        </div>

        <div className="flex justify-between gap-4">
          <span className="text-gray-600">Destination:</span>
          <span className="font-medium">{container.destination || "N/A"}</span>
        </div>

        <div className="flex justify-between gap-4">
          <span className="text-gray-600">Type:</span>
          <span className="font-medium">{container.containerType || "N/A"}</span>
        </div>

        <div className="flex justify-between gap-4">
          <span className="text-gray-600">Expected Arrival:</span>
          <span className="font-medium">
            {formatDate(container.expectedArrival)}
          </span>
        </div>

        <div className="flex justify-between gap-4">
          <span className="text-gray-600">Delivery Booked On:</span>
          <span className="font-medium">
            {formatDate(container.deliveryBookedOn)}
          </span>
        </div>

        <div className="flex justify-between gap-4">
          <span className="text-gray-600">Shipper:</span>
          <span className="font-medium">{container.shipper || "N/A"}</span>
        </div>

        <div className="flex justify-between gap-4">
          <span className="text-gray-600">Consignee:</span>
          <span className="font-medium">{container.consignee || "N/A"}</span>
        </div>
      </div>

      <div className="mt-4 flex gap-2 border-t pt-3">
        <button
          onClick={() => onView(container)}
          className="flex flex-1 items-center justify-center gap-1 rounded px-3 py-1.5 text-sm transition bg-gray-100 hover:bg-gray-200"
          type="button"
        >
          <FiEye size={14} /> View
        </button>
        <button
          onClick={() => onEdit(container)}
          className="flex flex-1 items-center justify-center gap-1 rounded px-3 py-1.5 text-sm transition bg-blue-50 text-blue-600 hover:bg-blue-100"
          type="button"
        >
          <FiEdit size={14} /> Edit
        </button>
        <button
          onClick={() => onDelete(container.id)}
          className="flex flex-1 items-center justify-center gap-1 rounded px-3 py-1.5 text-sm transition bg-red-50 text-red-600 hover:bg-red-100"
          type="button"
        >
          <FiTrash2 size={14} /> Delete
        </button>
      </div>
    </div>
  );
};

export default ContainerCard;